export default __webpack_public_path__ + "bace1a7eb70ee45d360269dc4e766120.png";